import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})

export class PermissionInquiryService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'permission-inquiry/rds';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'permission-inquiry/rds';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'permission-inquiry/rds';
    this.httpClient = http;
  }
}

